import nBossConnection from 'modules/base/service/nBossConnection';
import withReducer from 'app/store/withReducer';
import reducer from 'modules/ui/tablebrowser/store';
import TableBrowser from 'modules/ui/tablebrowser/TableBrowser';
import PiWriterTableService from '../service/PiWriterTableService';

const config = {
	key: 'piWriterTable',
	topic: 'piWriter',
	service: PiWriterTableService,
	editFormState: item => `/pi-writer/edit/${item ? item.id : 'new'}`,
	toolbarAction: ['search', 'refresh', 'new'],
	rowAction: ['exportData', 'modify', 'delete'],
	exportData: {
		tooltip: 'Export to XLSX',
		link: item => `${nBossConnection.basePath}piWriterTableControl/exportToXlsx?id=${item.id}`
	},
	columns: [
		{
			key: 'name'
		}
	]
};

function PiWriterTable() {
	return <TableBrowser config={config} />;
}

export default withReducer('piWriterTable', reducer('piWriterTable'))(PiWriterTable);